import { NewCodeValue } from "app/area/code-mappings/components/types";
import { LoadCodeItemsParams } from "app/area/code-mappings/types";
import { AccessCodetable } from "app/area/code-mappings/types-store";
import { manageOptionsButton } from "app/area/shared/manage-options";

interface GetManageOptions {
  label: string;
  codetable: NewCodeValue;
  loadOptionsParams: LoadCodeItemsParams;
  codetableAccess: AccessCodetable;
}

export const getManageOptions = ({
  label, codetable: { value: codetableId }, loadOptionsParams: { categoryId } = {}, codetableAccess
}: GetManageOptions) => (codetableAccess?.id === codetableId && !!codetableAccess?.administrationCentral)
  && manageOptionsButton(label, codetableId, [], categoryId);
